var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification"},[_c('strong',[_vm._v("Valor Unitario: ")]),_vm._v(_vm._s(parseFloat(_vm.vu.valorUnitario).toFixed(2))),_c('br'),_c('strong',[_vm._v("Dólar actual: ")]),_vm._v(_vm._s(parseFloat(_vm.vu.dolar).toFixed(2))),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49979ac5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sca_Componentes/componentes/CardValores.vue
// module id = 1654
// module chunks = 0